import { gql } from '@apollo/client';

import {
  LIST_ALL_RMA_CASES_OPERATION,
  GET_RMA_CASE_OPERATION,
  GET_COMMENTS_OPERATION,
} from 'utils/constants';

export const LIST_RMA_CASES = gql`
  query ${LIST_ALL_RMA_CASES_OPERATION}($accountId: ID!, $input: ListRmaCaseInput!) {
    getAccount(accountId: $accountId) {
      accountId
      listRmaCases(input: $input) {
        hasMore
        cases {
          id
          currencyCode
          contactName
          caseNumber
          rmaNumber
          status
          createdDate
          poNumber
          owner
          resolutionSummary
          lastModifiedDate
          items {
            serialNumber
          }
        }
      }
    }
  }
`;

export const GET_RMA_CASE = gql`
  query ${GET_RMA_CASE_OPERATION}($accountId: ID!, $input: GetRmaCaseInput!) {
    getAccount(accountId: $accountId) {
      accountId
      getRmaCaseByNumber(input: $input) {
        id
        currencyCode
        contactId
        contactName
        caseNumber
        rmaNumber
        status
        problemDescription
        owner
        caseType
        resolutionSummary
        createdDate
        lastModifiedDate
        poNumber
        attachmentCommentRelationships {
          commentId
          attachmentId
        }
        attachments {
          id
          name
          url
          description
          createdAt
        }
        shipping {
          method
          packingInstructions
          address {
            address1
            address2
            city
            state
            province
            zipcode
            country
          }
        }
        items {
          serialNumber
          partNumber
          partName
          price
          initialPrice
          status
          exceptionDescription
          failureDescription
          serviceActivity
          failureCode
          reviewDescription
        }
      }
    }
  }
`;

export const GET_CASE_COMMENTS = gql`
  query ${GET_COMMENTS_OPERATION}(
    $accountId: ID
    $input: GetRmaCaseInput!
    $caseId: String!
    $limit: Int = 50
    $offset: Int = 0
  ) {
    getAccount(accountId: $accountId) {
      accountId
      getRmaCaseByNumber(input: $input) {
        caseNumber
        getComments(caseId: $caseId, limit: $limit, offset: $offset) {
          count
          hasMore
          comments {
            id
            comment
            contactId
            createdBy {
              name
            }
            createdAt
          }
        }
      }
    }
  }
`;
